var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55235 23.9998C6.15806 23.9998 5.02334 22.8781 5.02334 21.4998C5.02334 20.1215 6.15806 18.9998 7.55235 18.9998H17.2315C19.7416 18.9998 21.7838 16.9809 21.7838 14.4995C21.7838 12.0182 19.7416 10 17.2315 10H10.4057V11.9995H17.2315C18.6258 11.9995 19.7605 13.1212 19.7605 14.4995C19.7605 15.8779 18.6258 16.9996 17.2315 16.9996H7.55235C5.04222 16.9996 3 19.0184 3 21.4998C3 23.9812 5.04222 26 7.55235 26H24V24.0005H7.55235V23.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39113 1.50619C7.2453 -0.502062 3.75453 -0.502062 1.60937 1.50619C-0.536458 3.51444 -0.536458 6.7814 1.60937 8.78902L4.71491 11.6954C5.14881 12.1015 5.8517 12.1015 6.28559 11.6954L9.39113 8.78902C11.5363 6.7814 11.5363 3.5138 9.39113 1.50619ZM7.95698 7.44744L5.49958 9.74665L3.04218 7.44744C1.6871 6.17924 1.6871 4.11596 3.04218 2.84839C3.71938 2.21461 4.60948 1.89708 5.49958 1.89708C6.38968 1.89708 7.2791 2.21398 7.95698 2.84839C9.31206 4.11659 9.31206 6.17924 7.95698 7.44744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3912 15.51C30.2459 13.4967 26.7543 13.4967 24.609 15.51C22.4637 17.5234 22.4637 20.7988 24.609 22.8115L27.6579 25.6728C28.1229 26.1091 28.8766 26.1091 29.3416 25.6728L32.3905 22.8115C34.5365 20.7988 34.5365 17.5228 32.3905 15.51H32.3912ZM30.9576 21.4665L28.5001 23.7723L26.0425 21.4665C24.6874 20.1951 24.6874 18.1265 26.0425 16.8557C26.7198 16.2203 27.6099 15.9019 28.5001 15.9019C29.3902 15.9019 30.2797 16.2197 30.9576 16.8557C32.3121 18.1271 32.3121 20.1957 30.9576 21.4665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackOrder);
export default __webpack_public_path__ + "static/media/TrackOrder.340c4dc90bf6530738b8b0a5d3058ccc.svg";
export { ForwardRef as ReactComponent };